import { useMutation, useQueryClient } from "@tanstack/react-query";

import { DeleteSignalResponse } from "./types";
import { getSignalsQueryKeyPrefix } from "./useGetSignals";

import { ENDPOINTS } from "@/api/application-api";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

interface DeleteSignalParams {
  workspaceId: number;
  signalId: number;
  userToken: string;
}

export const useDeleteSignal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      workspaceId,
      signalId,
      userToken,
    }: DeleteSignalParams): Promise<DeleteSignalResponse> => {
      const response = await fetch(ENDPOINTS.signals.delete(workspaceId, signalId), {
        method: "DELETE",
        headers: authHeader(userToken),
      });

      return handleResponse(response);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: getSignalsQueryKeyPrefix(variables.workspaceId),
      });
      displayToast("Signal deleted", ToastType.success);
    },
    onError: (error: Error) => {
      displayErrorToast(error.message);
    },
  });
};
